import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {ProjectInstallBidDetail} from '../models/project-install-bid-detail.interface';
import {ProjectInstallBidRequest} from "../models/project-install-bid-request.interface";
import {ProjectInstallBidQuestion} from "../models/project-install-bid-question.interface";
import {InstallerCrew} from "../models/installer-crew.interface";
import {InstallerBids} from "../models/installer-bids.interface";

@Injectable({
	providedIn: 'root'
})
export class InstallBidService {
	baseUrl: string = `${environment.url}/install`;
	constructor(private http: HttpClient) {}

	findOne(installerId: number, installDetailId: number): Observable<ProjectInstallBidDetail> {
		return this.http.get<ProjectInstallBidDetail>(`${this.baseUrl}/${installerId}/bid/${installDetailId}`);
	}

	findAttachment(installerId: number, installDetailId: number, fileHash: string): Observable<any> {
		return this.http.get<any>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/attachment/${fileHash}`);
	}

  retractBid(installerId: number, installDetailId: number): Observable<ProjectInstallBidRequest> {
    return this.http.put<ProjectInstallBidRequest>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/retract`, null);
  }

  noBid(installerId: number, installDetailId: number): Observable<ProjectInstallBidRequest> {
    return this.http.put<ProjectInstallBidRequest>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/no`, null);
  }

  acceptBid(installerId: number, installDetailId: number, bid: ProjectInstallBidRequest): Observable<ProjectInstallBidRequest> {
    return this.http.put<ProjectInstallBidRequest>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/accept`, bid);
  }

  getQuestions(installerId: number, installDetailId: number): Observable<ProjectInstallBidQuestion[]> {
    return this.http.get<ProjectInstallBidQuestion[]>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/questions`);
  }

  submitQuestion(installerId: number, installDetailId: number, question: ProjectInstallBidQuestion): Observable<ProjectInstallBidQuestion[]> {
    return this.http.post<ProjectInstallBidQuestion[]>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/questions`, question);
  }

  getCrew(installerId: number): Observable<InstallerCrew[]> {
    return this.http.get<InstallerCrew[]>(`${this.baseUrl}/${installerId}/crew`);
  }

  updateCrew(installerId: number, installDetailId: number, request: ProjectInstallBidRequest): Observable<ProjectInstallBidRequest> {
    return this.http.put<ProjectInstallBidRequest>(`${this.baseUrl}/${installerId}/bid/${installDetailId}/crew`, request);
  }

  getInstallerBids(installerId: number, active: boolean = true): Observable<InstallerBids> {
    let params = new HttpParams();
    if (!active) {
      params = params.append('active', active);
    }
    return this.http.get<InstallerBids>(`${this.baseUrl}/${installerId}/bids`, {params: params});
  }

}
